export const CategoriesResource = {
  name: "Categories",
  path: "/inventory/categories",
  access: ["read-categories"],
};
